import * as yup from 'yup'

export const lmsTrainingFormValidator = yup.object({
  // A string in the form, a number on the wire — see LmsTrainingForm.interface.ts. `/^\d+$/`
  // rejects fractional, negative and non-numeric input in one rule while still accepting '0'.
  externalId: yup
    .string()
    .trim()
    .required('External ID is required')
    .matches(/^\d+$/, 'External ID must be a whole number')
    // `/^\d+$/` alone accepts digit strings that cannot survive the page's `Number()`
    // conversion: 9007199254740993 becomes 9007199254740992, so the request would silently
    // persist a different external ID than the admin typed. Reject those here rather than
    // corrupting the record.
    .test('externalIdIsSafeInteger', 'External ID is too large to store accurately', (value) => {
      if (value === undefined || value === '') {
        return true
      }

      return Number.isSafeInteger(Number(value))
    }),
  // Validated here because the backend only checks `@IsString()` — a typo would otherwise be
  // stored and later handed to a contractor as a dead training link.
  url: yup.string().trim().url('Enter a valid URL').required('URL is required'),
  title: yup.string().trim().required('Title is required'),
  // Both optional, matching `@IsOptional @IsString` on AdminLmsTrainingCreateDto.
  description: yup.string().trim(),
  manualUploadRequirements: yup.string().trim(),
})
